module.exports = __webpack_public_path__ + "img/DSC_0093.1c5f674f.jpg";